<template>
  <b-modal
    id="view-contract-sales-manual-modal"
    v-model="isModalOpenLocal"
    title="View Contract Sales Manual"
    size="xl"
    @hidden="onClose"
  >
    <div class="service_replace_modal">
      <h1
        v-if="selectedContract !== null"
        class="header__title"
        style="text-align: left; width: 100%"
      >
        <strong> Contract: </strong> {{ selectedContract.code }} -
        {{ selectedContract.name }}
      </h1>
      <div class="d-flex align-items-center my-3">
        <h2 class="w-100"><strong> Sales Manuals </strong></h2>
        <BaseButton
          v-if="isAdmin"
          style="float: right"
          action="principal"
          @click="openNewSalesManualModal"
        >
          <p slot="text">Add Sales Manual</p>
        </BaseButton>
      </div>
      <div class="modal__body__content">
        <b-table
          v-if="salesManuals.length > 0"
          :data="salesManuals"
          per-page="10"
          paginated
          hoverable
        >
          <b-table-column
            v-slot="props"
            field="code"
            label="Code"
            width="20%"
            centered
          >
            {{ props.row.code }}
          </b-table-column>
          <b-table-column
            v-slot="props"
            field="countries"
            label="Countries"
            width="20%"
            centered
          >
            {{ props.row.countries.join(", ") }}
          </b-table-column>
          <b-table-column
            v-slot="props"
            field="code"
            label="From"
            width="15%"
            centered
          >
            {{ helpers.format(props.row.start_date, datesFormat) }}
          </b-table-column>
          <b-table-column
            v-slot="props"
            field="end_date"
            label="To"
            width="15%"
            centered
          >
            {{ helpers.format(props.row.end_date, datesFormat) }}
          </b-table-column>
          <b-table-column
            v-if="isAdmin && 0"
            v-slot="props"
            field="service_margin"
            label="Service Margin"
            width="30"
            centered
          >
            {{ props.row.service_margin }}
          </b-table-column>
          <b-table-column
            v-if="isAdmin && 0"
            v-slot="props"
            field="hotel_margin"
            label="Hotel Margin"
            width="30"
            centered
          >
            {{ props.row.hotel_margin }}
          </b-table-column>
          <b-table-column v-slot="props" label="Pax Range" width="12%" centered>
            {{ getPaxRange(props.row) }}
          </b-table-column>
          <b-table-column
            v-slot="props"
            field="last_import"
            label="Last Update"
            width="20%"
            centered
          >
            {{ lastServiceImportText(props.row) }}
          </b-table-column>
        </b-table>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
import { format } from "date-fns";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import helpers from "@/helpers";
import { DATE_FORMAT_MMM_DD_YYYY, USER_ROLE } from "@/constants";
import { datesHelper } from "@/utils/dates";

export default {
  name: "ViewContractSalesManualModal",
  components: { BaseButton },
  props: {
    selectedContract: {
      type: Object,
      default: () => {},
    },
    openNewSalesManualModal: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      authData: "auth/getAuthData",
      clientContracts: "client/getClientContracts",
      itinerary: "itinerary/getItinerary",
      isViewContractSalesManualModalOpen:
        "utils/getIsViewContractSalesManualModalOpen",
      datesFormat: "itinerary/getDatesFormat",
      sales_manuals: "sales_manual/list",
    }),
    isAdmin() {
      return helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.ADMIN, USER_ROLE.SUPPORT],
        true
      );
    },
    salesManuals() {
      const now = new Date();
      const lastYear = now.getFullYear() - 1;
      return this.selectedContractSalesManuals.data
        .filter((salesManual) => {
          const year = parseInt(salesManual.start_date.split("-")[0]);
          return year >= lastYear;
        })
        .map((salesManual) => {
          const countries = this.selectedContract.locations
            .filter((country) =>
              salesManual.location.some(
                (location) => location.id === country.id
              )
            )
            .map((location) => location.location_name);

          return {
            ...salesManual,
            countries: countries,
          };
        });
    },
    selectedContractSalesManuals() {
      return this.selectedContract?.sales_manual_contract || { data: [] };
    },
    isModalOpenLocal: {
      get() {
        return this.isViewContractSalesManualModalOpen;
      },
      set(value) {
        this.$store.dispatch(
          "utils/setIsViewContractSalesManualModalOpen",
          value
        );
      },
    },
  },
  data() {
    return {
      helpers: {
        format,
      },
    };
  },
  mounted() {
    if (this.isAdmin) {
      this.$store.dispatch("sales_manual/read");
    }
  },
  methods: {
    getPaxRange(item) {
      const salesManual = this.sales_manuals.find(
        (sm) => sm.code === item.code
      );
      if (salesManual) {
        const ranges = salesManual.qty_ranges.split(",");
        if (ranges.length) {
          const from = ranges[0].split("-")[0];
          const to = ranges[ranges.length - 1].split("-")[1];
          return `${from}-${to}`;
        }
      }
      return "-";
    },
    lastServiceImportText(item) {
      if (!item.last_import) return "-";

      return `${datesHelper.getDatetimeFromUTC(
        item.last_import,
        DATE_FORMAT_MMM_DD_YYYY
      )}`;
    },
    onClose() {
      this.isModalOpenLocal = false;
    },
  },
};
</script>
<style>
.service_replace_modal {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-radius: 1rem;
  padding: 2rem 2rem 3rem;
  text-align: center;
}
.service_replace_modal :is(h1, h2) {
  text-align: left;
}
.modal__body__content {
  width: 100%;
}
.service_replace_modal table :is(th, td) {
  font-size: 1rem;
}
@media screen and (max-width: 480px) {
  #view-contract-sales-manual-modal .animation-content {
    width: 90% !important;
  }
  .service_replace_modal {
    padding: 1.5rem !important;
  }
}
</style>
